var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPkiconSidebarGacha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "body",
    x1: 13,
    y1: 8,
    x2: 36,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEB3BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5D6470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252A33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glass",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19 9) rotate(55) scale(22 21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E6E8EF",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#878F9D",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252A33",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "darkSlot",
    x1: 16,
    y1: 32,
    x2: 33,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#11141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E5562"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 4,
    y: 4,
    width: 40,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 1.45,
    floodColor: "#000000",
    floodOpacity: 0.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 20.4C14.4 12.9 18.6 7.5 24 7.5C29.4 7.5 33.6 12.9 33.6 20.4V23.2H14.4V20.4Z",
    fill: "url(#glass)",
    stroke: "#F7F8FA",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 20.2C16.8 14.1 19.8 10.1 24 10.1C28.2 10.1 31.2 14.1 31.2 20.2",
    stroke: "#191D25",
    strokeOpacity: 0.7,
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 12.5C20.2 10.8 22.5 10.1 25.4 10.6",
    stroke: "#FFFFFF",
    strokeOpacity: 0.74,
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 16.1,
    width: 5.9,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-24 18.1 16.1)",
    fill: "#F4F5F8",
    stroke: "#252A33",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6,
    y: 14.2,
    width: 5.7,
    height: 3.5,
    rx: 1.75,
    transform: "rotate(23 24.6 14.2)",
    fill: "#D7DAE2",
    stroke: "#252A33",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 19,
    width: 6.1,
    height: 3.7,
    rx: 1.85,
    transform: "rotate(8 21.2 19)",
    fill: "#FFFFFF",
    stroke: "#252A33",
    strokeWidth: 0.65
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 23.1H35L37.3 40.8C37.5 42.2 36.4 43.5 35 43.5H13C11.6 43.5 10.5 42.2 10.7 40.8L13 23.1Z",
    fill: "url(#body)",
    stroke: "#F8F9FB",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 25.3H32.9L34.6 39.8H13.4L15.1 25.3Z",
    stroke: "#151922",
    strokeOpacity: 0.58,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 35.5H31.3",
    stroke: "url(#darkSlot)",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 36.9H29.8",
    stroke: "#F3F4F7",
    strokeOpacity: 0.72,
    strokeWidth: 0.9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30,
    r: 5.2,
    fill: "#F2F3F6",
    stroke: "#161A22",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1 30H26.9",
    stroke: "#232832",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30,
    r: 2.05,
    fill: "#C8CCD5",
    stroke: "#FFFFFF",
    strokeOpacity: 0.9,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 43.4H21",
    stroke: "#F3F4F7",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 43.4H33.5",
    stroke: "#F3F4F7",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2 8.7L37 11L39.3 11.8L37 12.6L36.2 14.9L35.4 12.6L33.1 11.8L35.4 11L36.2 8.7Z",
    fill: "#F6F7FA",
    stroke: "#242934",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkiconSidebarGacha);
export default __webpack_public_path__ + "static/media/pkicon-sidebar-gacha.2f5a2316145a2ca3be3bd25ae24912ae.svg";
export { ForwardRef as ReactComponent };